@if (getTabs().length > 0) {
  <div class="cpq-info-tabs">
    <ul class="nav nav-tabs mb-3" role="tablist">
      @for (tab of getTabs(); track tab) {
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="tab === activeTab" (click)="selectTab(tab)">
            {{ tab | translate }}
          </button>
        </li>
      }
    </ul>

    @if (activeTab === 'PARTS_INCLUDED') {
      <table class="table table-sm cpq-parts-included">
        <thead>
          <tr>
            <th translate>PRODUCT_ID</th>
            <th translate>NAME</th>
            <th class="text-right" translate>QUANTITY</th>
          </tr>
        </thead>
        <tbody>
          @for (part of parts; track part.productId) {
            <tr>
              <td>{{ part.productId }}</td>
              <td>{{ part.name }}</td>
              <td class="text-right">{{ part.quantity }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else if (getDocumentGroup(activeTab); as group) {
      <ul class="list-unstyled cpq-documents">
        @for (document of group.documents; track $index) {
          <li class="mb-2">
            <a target="_blank" [href]="document | gungDownloadUrl"><i class="fa-regular fa-file-arrow-down mr-2"></i>{{ getDocumentName(document) }}</a>
          </li>
        }
      </ul>
    }
  </div>
}
